import React, { FC } from 'react';

import { BaseButton, ButtonTypes } from 'components/base/BaseButton';

// detect open hide page
export const HiddenButton: FC = () => {
  return (
    <div
      style={{ position: 'fixed', bottom: '-100px', width: '1', height: '1' }}
    >
      <BaseButton type={ButtonTypes.Accent} to="/hide">
        Click
      </BaseButton>
    </div>
  );
};
